import { render } from "./AboutUsContact.vue?vue&type=template&id=276bc1e6&lang=pug"
import script from "./AboutUsContact.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutUsContact.vue?vue&type=script&setup=true&lang=js"

import "./AboutUsContact.vue?vue&type=style&index=0&id=276bc1e6&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__